<template>
  <footer class="footer">
    <div class="container footer-inner">
      <div class="footer-brand">
        <img :src="logo" alt="MTY Tools" />
        <span>MTY Tools</span>
      </div>
      <p class="footer-desc">
        Windows productivity apps · local-first · reliable · continuously updated
      </p>
      <a href="mailto:support@mtytools.com" class="footer-email">support@mtytools.com</a>
    </div>
    <div class="container footer-bottom">
      <span>&copy; 2026 MTY Tools</span>
      <span>
        <a href="/everyfile/productPrivacy">EveryFile Privacy</a>
        ·
        <a href="/everyfile/userAgreement">EveryFile Terms</a>
        ·
        <a href="/everyfile/vipService">EveryFile Membership</a>
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      logo: require('@/assets/leaf_logo_clean.png')
    }
  }
}
</script>

<style scoped>
.footer {
  background: var(--surface-dark);
  color: rgba(255, 255, 255, 0.55);
  padding: 56px 0 0;
  margin-top: auto;
}

.footer-inner {
  text-align: center;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.footer-brand img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.footer-brand span {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.02em;
}

.footer-desc {
  font-size: 14px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.45);
  max-width: 480px;
  margin: 0 auto 16px;
}

.footer-email {
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  padding: 6px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--radius);
  text-decoration: none;
}

.footer-email:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.28);
}

.footer-bottom {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  padding: 18px 0 28px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.35);
}

.footer-bottom a {
  color: rgba(255, 255, 255, 0.45);
  text-decoration: none;
}

.footer-bottom a:hover {
  color: #fff;
}
</style>
